import { render } from "./FluidsdataModel.vue?vue&type=template&id=1bde9c5a"
import script from "./FluidsdataModel.vue?vue&type=script&lang=js"
export * from "./FluidsdataModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__